export default "__VITE_ASSET__b5QNkjYz__"